import { TableState as OptimusTableState } from '@optimus-web/core';
import { CustomerClassification } from '@mews-commander/data-access';
import { ReservationsTableColumns } from '../columns';
import { ReservationTableFilters, ReservationsTableState } from '../../table';

type TableState = OptimusTableState<ReservationsTableState, ReservationTableFilters>;

export const useFilterParams = (filters: TableState['filters'] | undefined) => {
    if (!filters) return undefined;

    return {
        // CustomerClassifications enum converted to string in TableFilters type
        customerClassifications: filters[ReservationsTableColumns.Classifications]?.[0]?.value as
            | Array<CustomerClassification>
            | undefined,
        guestInHouseLoyaltyParameters: filters[ReservationsTableColumns.Loyalty]?.[0]?.value.map((value) =>
            JSON.parse(value)
        ),
    };
};
